import React from 'react';

import { VALIDATION_STORE_KEY, CART_STORE_KEY } from '@woocommerce/block-data';
import { useDispatch, useSelect, dispatch } from '@wordpress/data';
import {useState} from "@wordpress/element";
import { decodeEntities } from '@wordpress/html-entities';
import {__} from '@wordpress/i18n';

import Button from '@woocommerce/base-components/button';
import LoadingMask from '@woocommerce/base-components/loading-mask';
import {ValidatedTextInput, ValidationInputError} from '@woocommerce/blocks-components';

import {useStoreCartVouchers} from "./use-store-cart-vouchers";
import './gift-cards-form.scss';

const GiftVouchers = () => {
	const {
		giftCardInFlight,
		displayRegularForm,
		addGiftCardToList,
		isLoading
	} = useStoreCartVouchers();

	const [giftCardAmountFromInput, setGiftCardAmountFromInput] = useState('');

	const giftCardCode = giftCardInFlight.code;
	const maxBalanceFloat = giftCardInFlight.balance;
	const maxBalanceLocalized = giftCardInFlight.balanceLocalized;

	const cancelApplyingGiftCard = () => {
		displayRegularForm();
	}

	const { setValidationErrors } = useDispatch( VALIDATION_STORE_KEY );

	const handleError = (reason) => {
		setValidationErrors( {
			coupon: {
				message: decodeEntities( reason.message ),
				hidden: false,
			},
		} );
	}

	const handleGiftCardSubmit = (e) => {
		e.preventDefault();

		addGiftCardToList(giftCardCode, giftCardAmountFromInput)
			.then(response => {
				return dispatch( CART_STORE_KEY ).invalidateResolutionForStore();
			}).catch( reason => {
			handleError(reason);
			return Promise.resolve( false );
		});
	}

	const giftCardAmountInputId = `wc-block-components-totals-coupon__input-0`;

	const { amountValidationErrorId, hasValidationErrors } = useSelect( ( select ) => {
		const store = select( VALIDATION_STORE_KEY );
		return {
			hasValidationErrors: store.hasValidationErrors(),
			amountValidationErrorId: store.getValidationErrorId( giftCardAmountInputId ),
		};
	} );

	return (
		<LoadingMask
			screenReaderLabel={ __(
				'Applying coupon…',
				'woocommerce'
			) }
			isLoading={ isLoading }
			showSpinner={ false }>
			<div>{amountValidationErrorId}</div>
			<form
				className="wc-block-components-totals-gift-card__form"
				id="wc-block-components-totals-gift-card__form">

				<div className="wp-block-woocommerce-cart-order-summary-subtotal-block wc-block-components-totals-wrapper">
					<div className="wc-block-components-totals-item">
						<span className="wc-block-components-totals-item__label">{
							__('Gift card', 'voucherify')
						}:</span>
						<span className="wc-block-formatted-money-amount wc-block-components-formatted-money-amount
						 				wc-block-components-totals-item__value">{giftCardCode}</span>
					</div>

					<div className="wc-block-components-totals-item">
						<span className="wc-block-components-totals-item__label">{
							__('Available balance', 'voucherify')
						}:</span>
						<span className="wc-block-formatted-money-amount wc-block-components-formatted-money-amount
						 				wc-block-components-totals-item__value">{maxBalanceLocalized}</span>

					</div>
				</div>

				<ValidatedTextInput
					id={ giftCardAmountInputId }
					errorId="giftCardAmount"
					type="number"
					min="0.01"
					step="0.01"
					max={maxBalanceFloat}
					className="wc-block-components-totals-coupon__input"
					label={ __( 'Enter amount to apply', 'voucherify' ) }
					value={ giftCardAmountFromInput }
					ariaDescribedBy={ amountValidationErrorId }
					onChange={ ( newGiftCardAmountFromInput ) => {
						setGiftCardAmountFromInput( newGiftCardAmountFromInput );
					} }
					focusOnMount={ true }
					validateOnMount={ false }
					showError={ false }
				/>
				<ValidationInputError
					propertyName="giftCardAmount"
					elementId={ giftCardAmountInputId }/>

				<div className={"wc-block-components-totals-gift-card__buttons-container"}>
					<Button
						className="wc-block-components-totals-coupon__button"
						disabled={ isLoading || !giftCardAmountFromInput || hasValidationErrors }
						showSpinner={ isLoading }
						onClick={ handleGiftCardSubmit }
						type="submit"
					>
						{ __( 'Apply', 'woocommerce' ) }
					</Button>

					<Button
						className="wc-block-components-totals-coupon__button"
						showSpinner={ isLoading }
						onClick={ cancelApplyingGiftCard }
						type="submit"
					>
						{ __( 'Cancel', 'woocommerce' ) }
					</Button>
				</div>

			</form>

		</LoadingMask>
	);
}

export default GiftVouchers;
